import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { db, storage } from "../FirebaseConfig";

import {
  addDoc,
  arrayRemove,
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  arrayUnion,
  writeBatch,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

import {
  GithubAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

const auth = getAuth();
const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();
// class dataService {

//     PostData = (data, collectionName) => {
//         const collectionRef = collection(db, collectionName);

//         return addDoc(collectionRef, data);
//     };

//     updateData = (id, data, collectionName) => {
//         const updateCollection = doc(db, collectionName, id)

//         return updateDoc(updateCollection, data);
//     };

//     deleteData = (id, collectionName) => {
//         const deleteDataCollection = doc(db, collectionName, id)
//         return deleteDoc(deleteDataCollection)
//     };
//     getAllData = (collectionName) => {
//         const collectionRef = collection(db, collectionName);

//         return getDocs(collectionRef);
//     };

//     getdata = (id, collectionName,) => {
//         const getDataCollection = doc(db, collectionName, id)
//         return getDoc(getDataCollection);
//     };

// }

// upload Image

export const uploadImageFireBase = (
  filename,
  file,
  call_back,
  call_backPercent
) => {
  const storageRef = ref(storage, filename);

  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      call_backPercent(progress);
    },
    (error) => {
      alert(error);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        call_back(downloadURL);
      });
    }
  );
};

// post Data In FireBase

export const PostData = async (data, collectionName, call_back) => {
  console.log("data Post ==", data);
  const collectionRef = collection(db, collectionName);
  const res = await addDoc(collectionRef, data);
  call_back && call_back(res);
};

export const updateDataByID = async (id, data, collectionName, call_back) => {
  const updateCollection = doc(db, collectionName, id);

  let res = await updateDoc(updateCollection, data);
  call_back && call_back(res);
};

export const getDataById = async (collectionName, docId, call_back) => {
  try {
    const docRef = doc(db, collectionName, docId); // Reference to specific doc
    const docSnap = await getDoc(docRef); // Fetch document

    if (docSnap.exists()) {
      console.log("Document Data:", docSnap.data());
      call_back({ ...docSnap.data(), id: docSnap.id }); // Return data with ID
    } else {
      console.log("No such document!");
      call_back(null);
    }
  } catch (error) {
    console.error("Error fetching document:", error);
    call_back(null);
  }
};

// get Data In FireBase

export const getAllData = async (collectionName, call_back) => {
  let array = [];
  console.log("collectionName Post ==", collectionName);
  const collectionRef = collection(db, collectionName);
  const res = await getDocs(collectionRef);

  res.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    // console.log(doc.id, " => ", doc.data());
    array.push({ ...doc.data(), id: doc.id });
  });

  call_back(array);
};

// updateDocument in firebase
export const updateDocument = async (collectionName, docId, updatedData) => {
  const docRef = doc(db, collectionName, docId);
  await updateDoc(docRef, updatedData);
};

// 🔹 Experience Remove karne ka function

export const removeExperienceById = async (
  collectionName,
  docId,
  experienceId,
  call_back
) => {
  try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error("Document not found");
    }

    const data = docSnap.data();
    const experienceToRemove = data.Experience.find(
      (exp) => exp.id === experienceId
    );

    if (!experienceToRemove) {
      throw new Error("Experience not found");
    }

    await updateDoc(docRef, {
      Experience: arrayRemove(experienceToRemove),
    });

    console.log(`Experience with id ${experienceId} has been removed.`);
    call_back(true);
  } catch (error) {
    console.error("Error removing experience:", error);
    call_back(false);
  }
};

export const LoginFireBase = (email, password) => {
  const auth = getAuth();
  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      // ...
      console.log("userLogin", user);
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log("errorCode==", errorCode);
      console.log("errorMessage==", errorMessage);
    });
};

// ------------------------------------------------------------

export const getLibrarySidebarData = async () => {
  const querySnapshot = await getDocs(
    collection(db, "library_sidebar_categories_collection")
  );
  const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return data;
};

///////////////////////////////////////////////------------------------------------------------------

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    const user = result.user;

    console.log("Google Sign-In Success", user);

    return user;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error("Google Sign-In Error", errorCode, errorMessage);
    throw error;
  }
};

export const signInWithGithub = async () => {
  try {
    const result = await signInWithPopup(auth, githubProvider);
    const credential = GithubAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    const user = result.user;

    console.log("GitHub Sign-In Success", user);
    return user;
  } catch (error) {
    console.error("GitHub Sign-In Error", error.code, error.message);
    throw error;
  }
};
  
export const fetchUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const users = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Fetched users:", users);
    return users;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return [];
  }
};

// ----------------------------------------------------------------------

export const fetchIssue = async (issueId) => {
  try {
    const docRef = doc(db, "Issues", issueId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error("No such document exists!");
    }
  } catch (error) {
    throw new Error("Error fetching issue details: " + error.message);
  }
};

// -------------------------------------

export const fetchComments = async (issueId) => {
  const commentsRef = collection(db, "comments");
  const querySnapshot = await getDocs(commentsRef);
  let filteredComments = [];

  querySnapshot.forEach((doc) => {
    const commentData = doc.data();

    if (commentData.issueId === issueId) {
      filteredComments.push({
        id: doc.id,
        ...commentData,
      });
    }
  });

  return filteredComments;
};

export const addDocument = async (collectionName, data) => {
  try {
    const colRef = collection(db, collectionName);
    const docRef = await addDoc(colRef, data);
    return docRef.id;
  } catch (error) {
    console.error("Error adding document:", error);
    throw error;
  }
};
